import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TitleAndFaviconManager: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Set titles based on the current path
    switch (location.pathname) {
      case "/":
        document.title = "Eduvic";
        updateFavicon("/eduvic-favicon.png"); // Replace with your home favicon path
        break;
      case "/coaching":
        document.title = "Eduvic Coaching";
        updateFavicon("/eduvic-favicon.png"); // Replace with your home favicon path
        break;
      case "/technologies":
        document.title = "Eduvic Technologies";
        updateFavicon("/eduvic-favicon.png"); // Replace with your home favicon path
        break;
      default:
        document.title = "Eduvic";
        updateFavicon("/eduvic-favicon.png"); // Replace with your home favicon path
        break;
    }
  }, [location]);

  // Explicit type for the `iconPath` parameter
  const updateFavicon = (iconPath: string): void => {
    const link: HTMLLinkElement =
      document.querySelector("link[rel='icon']") || document.createElement("link");
    link.rel = "icon";
    link.href = iconPath;
    document.head.appendChild(link);
  };

  return null; // This component doesn't render anything
};

export default TitleAndFaviconManager;
